import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";

const FAQAutomationSection = () => {
  return <FAQSectionI18n translationPrefix="automationPage" itemClass="bg-secondary/50 rounded-xl border border-border px-6" />;
};

export default FAQAutomationSection;
